import React, { useContext, useState, useEffect } from "react";
import AppContext from "../contexts/AppContext";

import { makeStyles } from "@material-ui/core/styles";
import { createIssue, updateIssue, readStatus } from "../actions";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import FilledInput from "@material-ui/core/FilledInput";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Container from "@material-ui/core/Container";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import { baseStyle } from "../assets/theme/default";
import componentStyles from "../assets/styles/components/issue_form";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { useTranslation } from "react-i18next";
import { useProjectTracker } from "../hooks/useProjectTracker";

const useBaseStyles = makeStyles((theme) => baseStyle);
const useComponentStyles = makeStyles(componentStyles);

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const IssueForm = (props) => {
  const { state, dispatch } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [issueStatus, setIssueStatus] = useState("");
  const unCreatable = subject === "";

  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedDueDate, setSelectedDueDate] = useState();

  const [errorMessage, setErrorMessage] = useState(null);

  const [statusList, setStatusList] = useState("");
  const { t } = useTranslation();

  const {
    trackers,
    selectedTrackerId,
    setSelectedTrackerId,
    getProjectTrackers,
  } = useProjectTracker();

  const redmineurl = state.current.redmineurl;
  const apikey = state.current.apikey;
  const project_id = props.project_id;
  // const project_id = state.current.project.id

  const baseClasses = useBaseStyles();
  const componentClasses = useComponentStyles();
  const handleSetLanes = (val) => {
    props.stateChangefunc(val);
  };

  const handleClickCreateIssueOpen = () => setOpen(true);
  const handleClickCreateIssueClose = () => setOpen(false);
  const handleIssueCreate = async () => {
    const body = {
      issue: {
        project_id,
        subject,
        description,
        tracker_id: selectedTrackerId,
        assigned_to_id: state.current.user.id,
      },
    };
    // console.log('body: ', body)
    // await createIssue (redmineurl, apikey, dispatch, body)
    const res = await createIssue(redmineurl, apikey, dispatch, body);
    // console.log('response: ', res)
    if (props.stateChangefunc) handleSetLanes(res);
    if (res.errors) {
      setErrorMessage(res.errors);
    } else {
      setOpen(false);
    }
  };
  const handleIssueUpdate = async () => {
    // console.log('issue status: ', issueStatus)
    const body = {
      issue: {
        subject,
        description,
        status: issueStatus,
        start_date: selectedStartDate,
        due_date: selectedDueDate,
      },
    };
    // console.log('issue_body: ', body)
    await updateIssue(redmineurl, apikey, dispatch, state.issueDetail.id, body);
    setOpen(false);
  };

  const handleChange = (e) => {
    const status_id = e.target.value;
    const statusValue = statusList.find((status) => {
      return String(status.id) === String(status_id);
    });
    setIssueStatus(statusValue);
  };
  const handleChangeStartDate = (date) => {
    setSelectedStartDate(date.target.value);
  };
  const handleChangeDueDate = (date) => {
    setSelectedDueDate(date.target.value);
  };
  const handleErrorMessageClose = () => setErrorMessage(null);

  useEffect(() => {
    if (props.mode === "edit") {
      setSubject(state.issueDetail.subject);
      setDescription(state.issueDetail.description);
      setIssueStatus(state.issueDetail.status);
      setSelectedStartDate(state.issueDetail.start_date);
      setSelectedDueDate(state.issueDetail.due_date);
    } else {
      setSubject("");
      setDescription("");
      setIssueStatus("");
      setSelectedStartDate("");
      setSelectedDueDate("");
    }
  }, [state]);

  useEffect(() => {
    const readStatusFunc = async () => {
      if (state) {
        if (state.issueDetail.allowed_statuses) {
          setStatusList(state.issueDetail.allowed_statuses);
        } else {
          const res = await readStatus(redmineurl, apikey, dispatch);
          setStatusList(res);
        }
      }
    };
    readStatusFunc();
    return () => {
      setStatusList(null);
    };
  }, [state.issueDetail]);

  useEffect(() => {
    getProjectTrackers({
      project_id,
      redmineurl,
      apikey,
    });
  }, [redmineurl, apikey, project_id]);

  const onChangeTracker = (e) => setSelectedTrackerId(e.target.value);

  return (
    <>
      {props.mode === "edit" ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(e) => handleClickCreateIssueOpen()}
        >
          {t("button_edit")}
        </Button>
      ) : state.current.project && Object.keys(state.current.project).length ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(e) => handleClickCreateIssueOpen()}
        >
          {t("label_issue_new")}
        </Button>
      ) : (
        t("issue_form.text_set_project")
      )}

      <Dialog
        fullScreen
        open={open}
        onClose={handleClickCreateIssueClose}
        TransitionComponent={Transition}
      >
        <AppBar className={baseClasses.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClickCreateIssueClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h1" className={baseClasses.title}>
              {props.mode === "edit"
                ? t("label_issue_update")
                : t("label_issue_new")}
            </Typography>
          </Toolbar>
        </AppBar>

        <Container
          maxWidth={false}
          component={Box}
          classes={{ root: componentClasses.containerRoot }}
        >
          <Card classes={{ root: componentClasses.cardRoot }}>
            <CardContent>
              <Grid container>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormLabel>{t("field_subject")}</FormLabel>
                    <FormControl
                      variant="filled"
                      component={Box}
                      width="100%"
                      marginBottom="1rem!important"
                    >
                      <Box
                        paddingLeft="0.75rem"
                        paddingRight="0.75rem"
                        component={FilledInput}
                        // autoComplete="off"
                        type="text"
                        defaultValue={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormLabel>{t("field_description")}</FormLabel>
                    <FormControl variant="filled" component={Box} width="100%">
                      <Box
                        paddingLeft="0.75rem"
                        paddingRight="0.75rem"
                        component={FilledInput}
                        // autoComplete="off"
                        multiline
                        rows="10"
                        defaultValue={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>

              {props.mode === "edit" ? (
                <Grid container>
                  <Grid item xs={12} lg={4}>
                    <FormGroup>
                      <FormLabel>{t("field_status")}</FormLabel>
                      <FormControl
                        variant="filled"
                        component={Box}
                        width="100%"
                        marginBottom="1rem!important"
                      >
                        <Box>
                          <Select
                            value={issueStatus ? issueStatus.id : ""}
                            onChange={(e) => handleChange(e)}
                            inputProps={{
                              name: "status",
                              id: "age-native-label-placeholder",
                            }}
                          >
                            {statusList
                              ? statusList.map((st, index) => {
                                  return (
                                    <MenuItem key={index} value={st.id}>
                                      {st.name}
                                    </MenuItem>
                                  );
                                })
                              : ""}
                          </Select>
                        </Box>
                      </FormControl>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormGroup>
                      <FormLabel>{t("field_start_date")}</FormLabel>
                      <FormControl
                        variant="filled"
                        component={Box}
                        width="100%"
                        marginBottom="1rem!important"
                      >
                        <Box
                          paddingLeft="0.75rem"
                          paddingRight="0.75rem"
                          component={FilledInput}
                          autoComplete="off"
                          type="date"
                          defaultValue={selectedStartDate}
                          onChange={(e) => handleChangeStartDate(e)}
                        />
                      </FormControl>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormGroup>
                      <FormLabel>{t("field_due_date")}</FormLabel>
                      <FormControl
                        variant="filled"
                        component={Box}
                        width="100%"
                        marginBottom="1rem!important"
                      >
                        <Box
                          paddingLeft="0.75rem"
                          paddingRight="0.75rem"
                          component={FilledInput}
                          type="date"
                          defaultValue={selectedDueDate}
                          onChange={(e) => handleChangeDueDate(e)}
                        />
                      </FormControl>
                    </FormGroup>
                  </Grid>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={12} lg={4}>
                    <FormGroup>
                      <FormLabel>{t("field_tracker")}</FormLabel>
                      <FormControl
                        variant="filled"
                        component={Box}
                        width="100%"
                        marginBottom="1rem!important"
                      >
                        <Box>
                          <Select
                            id="issue-filter-status"
                            onChange={(e) => onChangeTracker(e)}
                            value={selectedTrackerId}
                          >
                            {trackers.map((tracker, index) => (
                              <MenuItem key={index} value={tracker.id}>
                                {tracker.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </FormControl>
                    </FormGroup>
                  </Grid>
                </Grid>
              )}
            </CardContent>
            <Box
              classes={{ root: componentClasses.cardActionsRoot }}
              component={CardActions}
              justifyContent="flex-end"
            >
              <Button
                classes={{ root: componentClasses.buttonCancel }}
                onClick={handleClickCreateIssueClose}
              >
                {t("button_cancel")}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={
                  props.mode === "edit" ? handleIssueUpdate : handleIssueCreate
                }
                disabled={unCreatable}
              >
                {t("button_save")}
              </Button>
            </Box>
          </Card>
        </Container>
      </Dialog>

      <Snackbar open={errorMessage}>
        <Alert onClose={handleErrorMessageClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default IssueForm;
